import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from 'src/app/shared/shared.module';

import { MegaMenuModule } from '../../components/mega-menu/mega-menu.module';
import { NavigationItemModule } from '../../components/navigation-item/navigation-item.module';
import { ToolbarNotificationsModule } from '../../components/toolbar-notifications/toolbar-notifications.module';
import { ToolbarUserModule } from '../../components/toolbar-user/toolbar-user.module';
import { ContainerModule } from '../../directives/container/container.module';
import { NavigationModule } from '../navigation/navigation.module';
import { ToolbarComponent } from './toolbar.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [ToolbarComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatRippleModule,
    MatTooltipModule,
    FontAwesomeModule,
    ToolbarNotificationsModule,
    ToolbarUserModule,
    NavigationModule,
    RouterModule,
    NavigationItemModule,
    MegaMenuModule,
    ContainerModule,
    SharedModule
  ],
  exports: [ToolbarComponent]
})
export class ToolbarModule {}
